import { PROCESS } from "@/lib/constants";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/Reveal";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 40%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section ref={ref} className="relative section-pad overflow-hidden" data-testid="process-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 md:col-span-6">
            <div className="overline mb-4">04 · Process</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              A cadence you can<br /><span className="italic text-gradient">actually feel</span>.
            </h2>
          </div>
        </div>

        <div className="relative pl-6 md:pl-16">
          {/* Progress rail */}
          <div className="absolute left-0 md:left-6 top-0 bottom-0 w-px bg-[color:var(--border)]" />
          <motion.div
            style={{ scaleY, transformOrigin: "top" }}
            className="absolute left-0 md:left-6 top-0 bottom-0 w-px bg-gradient-to-b from-brand-primary via-brand-secondary to-brand-accent"
          />

          <div className="space-y-14">
            {PROCESS.map((p, i) => (
              <Reveal key={p.step} delay={i * 0.05}>
                <div className="relative grid grid-cols-12 gap-4">
                  {/* Dot */}
                  <span
                    className="absolute -left-[26px] md:-left-[68px] top-1.5 w-3 h-3 rounded-full bg-[color:var(--bg)] border-2 border-brand-primary"
                    aria-hidden
                  />
                  <div className="col-span-12 md:col-span-2 chapter-num">{p.step}</div>
                  <div className="col-span-12 md:col-span-4">
                    <h3 className="font-serif text-3xl md:text-4xl tracking-tight">{p.title}</h3>
                  </div>
                  <div className="col-span-12 md:col-span-5 md:col-start-8">
                    <p className="text-[15px] leading-relaxed text-[color:var(--text-muted)]">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
